import { render, staticRenderFns } from "./SurveyImprovementComments.vue?vue&type=template&id=7f709c64&"
import script from "./SurveyImprovementComments.vue?vue&type=script&lang=js&"
export * from "./SurveyImprovementComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports